import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-image-popup',
    templateUrl: './image-popup.component.html',
    styleUrls: ['./image-popup.component.scss'],
    standalone: false
})
export class ImagePopupComponent {
  @Input() imageSrc: string | null = 'null';
  @Input() isOpen: boolean = false;
  @Output() close = new EventEmitter<void>();

  closePopup(): void {
    this.close.emit();
  }
}
